export default __webpack_public_path__ + "static/media/video-background.30fa7bdd.mp4";